@if (images?.length && config) {
  <htm-swiper
    [config]="config"
    [class.swiper-single-item]="images?.length === 1"
    >
    @if (images.length > 1 && firstImageLoaded && showExpandLink) {
      <a
        href="javascript:void(0)"
        attr.aria-label="{{ 'gallery.link-title' | translate }}"
        class="expand-gallery"
        (click)="openGallery()"
        data-test-id="gallery-open-link"
        >
        {{ 'gallery.link-title' | translate }} ({{ images.length }})
      </a>
    }
    <button
      htm-button
      theme="icon"
      class="slides__arrow slides__arrow--left"
      aria-label="Previous slide"
      data-test-id="gallery-previous-slide-button"
      >
      <icon
        glyph="chevron-left"
        size="large"
        [bg]="true"
        aria-hidden="true"
      ></icon>
    </button>
    <button
      htm-button
      theme="icon"
      class="slides__arrow slides__arrow--right"
      aria-label="Next slide"
      data-test-id="gallery-next-slide-button"
      >
      <icon
        glyph="chevron-right"
        size="large"
        [bg]="true"
        aria-hidden="true"
      ></icon>
    </button>
    <div
      class="swiper-wrapper"
      aria-roledescription="carousel"
      aria-live="polite"
      >
      @for (image of images; track image; let i = $index; let l = $count) {
        <div
          class="swiper-slide slides__instance"
          role="group"
          aria-roledescription="slide"
          [attr.aria-label]="'slide ' + (i + 1) + ' of ' + l"
          >
          @if (!image.videoId) {
            <img
              [src]="image.derivative?.url || activeImage.url"
              [title]="image.title"
              [alt]="image.alt"
              (load)="coverImageLoaded()"
              />
          }
          @if (image.videoId) {
            <htm-video
              [untabbable]="activeIndex !== i"
              [videos]="image"
              (onLoad)="coverImageLoaded()"
            ></htm-video>
          }
          @if (image?.videoDescription || image?.title) {
            <div
              class="image__title"
              >
              {{ image.videoDescription || image.title }}
            </div>
          }
        </div>
      }
    </div>
    <div class="swiper-pagination"></div>
  </htm-swiper>
}

<htm-modal [id]="_id" [bottomAction]="false" [blockModal]="false">
  <ng-template>
    <div
      class="gallery-container"
      attr.aria-label="{{ 'gallery.title' | translate }}"
      >
      <div class="navigation-prev flex">
        <button
          attr.aria-label="{{ 'gallery.prev' | translate }}"
          htm-button
          theme="icon"
          (click)="handlePrev(activeImage)"
          data-test-id="gallery-modal-previous-slide-button"
          >
          <icon glyph="chevron-left" size="large" [bg]="true"></icon>
        </button>
      </div>
      <div class="gallery__items">
        <div class="gallery__items__index">
          {{ activeImage?.index + 1 }} / {{ images?.length }}
        </div>
        <div class="gallery__items__picture-container">
          <div class="gallery__items__active-image">
            <div class="navigation-prev flex">
              <button
                attr.aria-label="{{ 'gallery.prev' | translate }}"
                htm-button
                theme="icon"
                (click)="handlePrev(activeImage)"
                data-test-id="gallery-modal-active-image-previous-slide-button"
                >
                <icon glyph="chevron-left" size="small" [bg]="true"></icon>
              </button>
            </div>
            @if (!activeImage?.videoId) {
              @if (activeImage?.title) {
                <div
                  class="gallery__items__active-image__title"
                  >
                  {{ activeImage?.title }}
                </div>
              }
              <img
                [src]="activeImage?.derivative?.url || activeImage.url"
                [title]="activeImage?.title ? activeImage.title : ''"
                [alt]="activeImage?.alt"
                />
              }
              @if (activeImage?.videoId) {
                <htm-video
                  [videos]="activeImage"
                  [responsive]="true"
                ></htm-video>
              }
              <div class="navigation-next flex">
                <button
                  attr.aria-label="{{ 'gallery.next' | translate }}"
                  htm-button
                  theme="icon"
                  (click)="handleNext(activeImage)"
                  data-test-id="gallery-modal-active-image-next-slide-button"
                  >
                  <icon glyph="chevron-right" size="small" [bg]="true"></icon>
                </button>
              </div>
            </div>
            <div class="gallery__items__navigation">
              @for (image of images; track image) {
                <a
                  href="javascript:void(0)"
                  (keyup)="handlePreviewEnter($event, image)"
								attr.aria-current="{{ (!image.videoId && activeImage.derivative?.url === image.derivative?.url)
                  || (image.videoId && activeImage.input === image.input) ? true : false }}"
                  [attr.data-test-id]="'gallery-modal-image-preview-' + (image?.title || image?.videoId || image?.url)"
                  >
                  @if (!image.videoId) {
                    <img
									class="{{
										(activeImage.derivative
											? activeImage.derivative?.url === image.derivative?.url
											: image.url === activeImage.url) ? 'active' : '' }}"
                      [src]="image.derivative?.url || image.url"
                      [alt]="image.alt"
                      [title]="image.title || ''"
                      (click)="activeImage = image"
                      />
                  }
                  @if (image.videoId) {
                    <img
                      class="{{ activeImage.input === image.input ? 'active' : '' }}"
                      [src]="image.videoThumbnail"
                      [alt]="image.videoDescription || ''"
                      [title]="image.title || ''"
                      (click)="activeImage = image"
                      />
                  }
                </a>
              }
            </div>
          </div>
        </div>
        <div class="navigation-next flex">
          <button
            attr.aria-label="{{ 'gallery.next' | translate }}"
            htm-button
            theme="icon"
            (click)="handleNext(activeImage)"
            data-test-id="gallery-modal-next-slide-button"
            >
            <icon glyph="chevron-right" size="large" [bg]="true"></icon>
          </button>
        </div>
      </div>
    </ng-template>
  </htm-modal>
